module.exports = __webpack_public_path__ + "img/5602f44.png";